import { Component } from '@angular/core';

@Component({
  selector: 'app-header-internships',
  templateUrl: './header-internships.component.html',
  styleUrls: ['./header-internships.component.css']
})
export class HeaderInternshipsComponent {

}
